/*
 * Open roles.
 *
 * Structured rather than markdown (the blog's approach) because a job post is
 * a form, not prose: the facts strip, the day-to-day list and the two
 * requirement lists each render differently, and a candidate scans them in that
 * order. Keeping the shape explicit is what lets the page stay scannable when
 * there are four roles instead of one.
 *
 * Add a role by adding an object here. Nothing else needs registering: the
 * index and the detail route both read this array, and an empty array renders
 * the no-openings state rather than a broken page.
 *
 * `slug` is the URL and is permanent once a listing is posted to a job board.
 * Rename the title freely; don't rename the slug.
 */

export const CONTACT_EMAIL = 'hello@zenbul.com';

/* Filled 2026-09: `hardware-engineering-intern`. The full listing is in git
   history (last present at 644092e); reuse that slug if it is ever reposted,
   since it is already on school job boards. */
const ROLES = [];

export default ROLES;
